import { Tag } from 'antd';
import type { ColumnsType } from "antd/es/table";
import { formatTimeStampToHoras } from "../../helpers/timestampToHoras";
import { ClienteType, tipoAcoes } from "../../types/ClienteTypes";

export const columnsDefs: ColumnsType<ClienteType> = [
  // {
  //   title: "Nome",
  //   dataIndex: "nome",
  //   key: "nome",
  //   render: (text) => text,
  // },
  {
    title: "Endereço",
    dataIndex: "endereco",
    key: "endereco",
    // defaultSortOrder: 'descend',
    // sorter: (a, b) => a.endereco.length - b.endereco.length,
    // defaultSortOrder: 'ascend',
  },
  {
    title: "Tipo ação",
    key: "acoes",
    dataIndex: "acoes",
    render: (_, { acoes }) => (
      <>
        {acoes.map((tag: tipoAcoes) => {
          let color = tag.length > 5 ? "geekblue" : "green";
          if (tag.tipoAcao === "Trabalhista") {
            color = "volcano";
          }
          return (
            <Tag
              // color={color}
              key={tag.id}>
              {tag.tipoAcao.toUpperCase()}
            </Tag>
          );
        })}

      </>
    ),
  },
  {
    title: "Contato",
    dataIndex: "contato",
    key: "contato",
    render: (text) => {
      if (text === 'undefined') {
        return '';
      }
      return <>{text}</>;
    },
  },
  {
    title: "Data criação",
    dataIndex: "created_at",
    key: "created_at",
    render: (text) => <>{formatTimeStampToHoras(text)}</>,
    sorter: (a, b) => a.created_at.localeCompare(b.created_at),
  },
];

export default columnsDefs;
